import * as React from 'react';
import { ISeedProduct, ISeedAttributeValue, IDocument } from 'src/infrastructure/interfaces';
import MarkdownRenderer from '../../Editor/components/CropPageView/common/MarkdownRenderer';
import { SeedCategory } from 'src/infrastructure/enums';
import './TypeSeedTable.css';

export interface ITypeSeedTable {
  product: ISeedProduct;
  document?: IDocument;
}

export interface ITableRowConfig {
  name?: string
  value: string[],
} 

export default class TypeSeedTable extends React.Component<ITypeSeedTable> {
  categoryAttributes: ITableRowConfig[];

  constructor(props: ITypeSeedTable) {
    super(props);

    this.categoryAttributes = this.attributesPerCategory();
  }

  render() {

    const docType = this.props.document ? this.props.document.type : "";

    return (
      <table className={`${docType} seed-attribute-table row-count-${this.categoryAttributes.length}`}>
        <tbody>
          {this.categoryAttributes.map((row: ITableRowConfig, index: number) => {
            const value = this.attributeValue(row.value, '; ');
            if (value !== '') {
              return (
                <tr key={index}>
                  <td className={index % 2 === 0 ? 'odd' : 'even'}>{row.name || this.attributeName(row.value)}</td>
                  <td><MarkdownRenderer markdown={value} /></td>
                </tr>
              );
            }
            return '';
          })}
        </tbody>
      </table>
    );
  }

  attributesPerCategory(): ITableRowConfig[] {
    const {
      category: {
        id: categoryId,
      }
    } = this.props.product;
    switch (categoryId) {
      case SeedCategory.Canola:
        return [
          { value: ['Yield'] },
          { value: ['BlackLeg'] },
          { value: ['FusariumWilt'] },
          { value: ['Standability'] },
          { value: ['DaysToFlower'] },
          { value: ['DaysToMaturity'] },
          { value: ['Height'] },
        ];
      default:
        return [];
    }
  }

  attributeValue(name: string|string[], delimiter: string = ''): string {
    const {
      attributes,
    } = this.props.product;
    const value: string[] = [];
    const names: string[] = typeof name === 'string' ? [name] : name;
    attributes.forEach((attrData: ISeedAttributeValue) => {
      if (names.includes(attrData.attribute.name)) {
        value.push(attrData.value);
      }
    });
    return value.join(delimiter);
  }

  attributeName(name: string|string[]): string {
    const {
      attributes,
    } = this.props.product;
    let title = '';
    const findName: string = typeof name === 'string' ? name : name[0];
    attributes.forEach((attrData: ISeedAttributeValue) => {
      if (attrData.attribute.name === findName) {
        title = attrData.attribute.productDescriptionDisplayName;
      }
    });
    return title;
  }

}



// WEBPACK FOOTER //
// ./src/components/Products/components/TypeSeedTable.tsx